@use '../../../../styles/scss/vcom/mixins/breakpoints';
@use '../../../../styles/scss/vcom/mixins/rtl';
@use '../../../../styles/scss/vcom/themes/classic/colors' as classic;

:root {
  --carousel-thumb-width: 80px;
  --carousel-container-width: 20000px;
}
.vs-toggle-autoscroll {
  position: absolute;
  bottom: 0px;
  padding: 15px 15px 50px 15px;
  z-index: 2;

  button{
    &:hover {
      cursor: pointer;
    }
    &.vs-tab-focused {
      outline-offset: -6px;
      outline: 1px dashed black;
    }
  }
}
/* START GENAI */
/* Apply styles only to <ul> with class 'vs-carousel-desktop-list'
   that contains a child with class 'sct' or 'ect' */
   ul.vs-carousel-desktop-list:has(.vs-sct, .vs-ect) {
    transform-style: preserve-3d;
  }

  /* END GENAI */
// START GENAI
.vs-carousel-skeleton {
  width: 100%;
  padding: 20px;
  background-color: #f0f0f0;

  &-wrapper {
    display: flex;
    overflow-x: hidden;
    padding: 15px 0; // Match padding of carousel items
  }

  &-item {
    min-width: 300px;
    margin-right: 20px;
    padding-right: 5px;
    padding-left: 5px;

    @include breakpoints.tablet-up {
      width: 60vw;
      padding-right: 15px;
      padding-left: 15px;
    }

    @include breakpoints.desktop-up {
      width: calc((100vw * (10 / 12)) / 2);
    }

    @include breakpoints.desktop-plus-up {
      width: calc(1140px / 2);
    }

    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  &-image {
    height: 200px;
    width: 100%;
    background-color: #e0e0e0;
    margin-bottom: 10px;
  }

  &-text {
    width: 100%;

    .vs-carousel-skeleton-title {
      height: 20px;
      width: 80%;
      background-color: #e0e0e0;
      margin-bottom: 10px;
    }

    .vs-carousel-skeleton-description {
      height: 15px;
      width: 60%;
      background-color: #e0e0e0;
    }
  }

  &-nav {
    display: flex;
    justify-content: space-between;
    margin-top: 20px;
  }

  &-button {
    width: 40px;
    height: 40px;
    background-color: #e0e0e0;
    border-radius: 50%;
  }
}

// Add animation
@keyframes skeleton-loading {
  0% {
    background-color: #e0e0e0;
  }
  50% {
    background-color: #f0f0f0;
  }
  100% {
    background-color: #e0e0e0;
  }
}

.vs-carousel-skeleton {
  &-image,
  &-title,
  &-description,
  &-button {
    animation: skeleton-loading 1.5s infinite;
  }
}
.vs-carousel-nav {
  .vs-carousel-container-btn {
    border: 0px;
    background-color: #{classic.$vs-white};
    background-color: white;
    border-radius: 50%;
    position: absolute;
    cursor: pointer;
    bottom: calc(50%);
    z-index: 3;
    opacity: 0.8;
    line-height: 100%;
    font-size: 25px;
    padding: 10px;
    box-shadow: 0 0 5px rgba(0, 0, 0, 0.14);
    font-family: 'visa-icon', sans-serif;
    color: #5c5c5c;

    &.vs-autoplay-nav {
      bottom: calc(50%);
    }

    &.vs-autoplay-nav:has(.vs-content-bundle) {
      bottom: calc(50% + 115px);
    }

    &:hover,
    &:focus {
      opacity: 1;
      box-shadow: 0 0 10px 5px rgba(0, 0, 0, 0.14);
    }

    &.vs-rt-btn {
      right: 7px;

      &::after {
        content: '\e71b';
        line-height: normal;
      }

      @include breakpoints.desktop-up {
        right: 20px;
      }

      @include breakpoints.desktop-plus-up {
        right: 40px;
      }
    }

    &.vs-lt-btn {
      left: 7px;

      &::after {
        content: '\e71a';
        line-height: normal;
      }

      @include breakpoints.desktop-up {
        left: 20px;
      }

      @include breakpoints.desktop-plus-up {
        left: 40px;
      }
    }

    &:focus {
      outline-offset: -5px;
      outline: dashed black 1px;
      color: #2c2c2c;
    }

    &:hover {
      color: #2c2c2c;
    }

    @include breakpoints.desktop-up {
      line-height: 100%;
      font-size: 40px;
      padding: 15px;
    }
  }
}
vs-carousel-container {
  user-select: none;
  .vs-alt-bg {
    background-color: classic.$vs-tertiary-1;
  }

  .vs-carousel-container {
    position: relative;
    overflow: hidden;

    &.vs-pb-btn {
      padding-bottom: 115px;
    }

    .vs-carousel-container-wrapper {
      padding-top: 30px;
      position: relative;
      margin: 0 auto;
      max-width: 100vw;
    }

    ul {

      &.vs-carousel-container-content {
        display: flex;
        height: fit-content;
        list-style: none;
        margin: 0;
        padding: 0;
        -ms-overflow-style: none;
        scrollbar-width: none;
        &::-webkit-scrollbar {
          display: none;
        }

        &:focus-within {
          li {
            &.vs-tab-focused {
              outline-offset: -2px;
              box-shadow: 0 0 0px 2px white;
              outline: 2px dashed black;
            }
          }
        }
      }
    }

    li {
      display: flex;
      word-break: break-word;
      padding-right: 5px;
      padding-left: 5px;
      flex-shrink: 0;
      width: 75vw;

      @include breakpoints.tablet-up {
        width: 60vw;
      }

      @include breakpoints.desktop-up {
        width: calc((100vw * (10 / 12)) / 2)
      }

      &:has(.vs-icon-bundle) {
        justify-content: center;
      }

      &:has(.vs-content-bundle[data-layout='2up']) {
        @include breakpoints.desktop-plus-up {
          width: calc(1140px / 2);
        }
      }

      &:has(.vs-content-bundle[data-layout='3up']) {
        @include breakpoints.desktop-plus-up {
          width: calc(1140px / 3);
        }
      }

      &:has(.vs-ect[data-layout='2up']),
      &:has(.vs-sct[data-layout='2up']) {
        width: 280px;
        @include breakpoints.tablet-up{
          width: calc(1140px / 2);
        }
        @include breakpoints.desktop-up{
          width: calc(1140px / 2);
          }
          @include breakpoints.desktop-plus-up{
            width: calc(1140px / 2);
          }
      }

      &:has(.vs-ect[data-layout='3up']),
      &:has(.vs-sct[data-layout='3up']) {
        width: 280px;
        @include breakpoints.tablet-up{
          width: calc(1140px / 3);
        }
        @include breakpoints.desktop-up{
          width: calc(1140px / 3);
          }
          @include breakpoints.desktop-plus-up{
            width: calc(1140px / 3);
          }
      }

      &:has(.vs-offer-bundle[data-layout='2up']) {
        width: 75vw;

        @include breakpoints.tablet-up {
          width: calc(729px / 2);
        }

        @include breakpoints.desktop-up {
          width: calc(942px / 2);
        }

        @include breakpoints.desktop-plus-up {
          width: calc(1140px / 2);
        }
      }

      &:has(.vs-offer-bundle[data-layout='3up']) {

        @include breakpoints.tablet-up {
          width: calc(729px / 2);
        }

        @include breakpoints.desktop-up {
          width: calc(942px / 3);
        }

        @include breakpoints.desktop-plus-up {
          width: calc(1140px / 3);
        }
      }

      &:has(.vs-icon-bundle[data-layout='2up']) {
        justify-content: center;

        @include breakpoints.desktop-plus-up {
          width: calc(1140px / 2);
        }
      }

      &:has(.vs-icon-bundle[data-layout='3up']) {
        justify-content: center;
        @include breakpoints.desktop-plus-up {
          width: calc(1140px / 3);
        }
      }

      @include breakpoints.tablet-up {
        padding-right: 15px;
        padding-left: 15px;
      }
      img {
        pointer-events: none;
      }
    }

    &:has(.vs-content-bundle[data-layout='2up']) {
      li:first-child, li:only-child {
        @include breakpoints.desktop-plus-up {
          width: 50vw;
          padding-right: 15px;
          padding-left: calc(50vw - (1140px / 2 - 15px));

          @include rtl.rtl {
            padding-left: 15px;
            padding-right: calc(50vw - (1140px / 2 - 15px));
          }
        }
      }

      li:last-child:not(:only-child) {
        @include breakpoints.desktop-plus-up {
          width: 50vw;
          padding-left: 15px;
          padding-right: calc(50vw - (1140px / 2 - 15px));

          @include rtl.rtl {
            padding-right: 15px;
            padding-left: calc(50vw - (1140px / 2 - 15px));
          }
        }
      }
    }

    &:has(.vs-content-bundle[data-layout='3up']) {
      li:first-child, li:only-child {
        @include breakpoints.desktop-plus-up {
          width: calc((1140px / 3) + ((100vw - 1140px) / 2));
          padding-right: 15px;
          padding-left: calc(((100vw - 1140px) / 2) + 15px);

          @include rtl.rtl {
            padding-left: 15px;
            padding-right: calc(((100vw - 1140px) / 2) + 15px);
          }
        }
      }

      li:last-child:not(:only-child) {
        @include breakpoints.desktop-plus-up {
          width: calc((1140px / 3) + ((100vw - 1140px) / 2));
          padding-left: 15px;
          padding-right: calc(((100vw - 1140px) / 2) + 15px);

          @include rtl.rtl {
            padding-right: 15px;
            padding-left: calc(((100vw - 1140px) / 2) + 15px);
          }
        }
      }
    }

    &:has(.vs-ect[data-layout='2up']),
    &:has(.vs-sct[data-layout='2up']) {
      li:first-child, li:only-child {
        @include breakpoints.desktop-plus-up {
          width: 50vw;
          padding-right: 15px;
          padding-left: calc(50vw - (1140px / 2 - 15px));

          @include rtl.rtl {
            padding-left: 15px;
            padding-right: calc(50vw - (1140px / 2 - 15px));
          }
        }
      }

      li:last-child:not(:only-child) {
        @include breakpoints.desktop-plus-up {
          width: 50vw;
          padding-left: 15px;
          padding-right: calc(50vw - (1140px / 2 - 15px));

          @include rtl.rtl {
            padding-right: 15px;
            padding-left: calc(50vw - (1140px / 2 - 15px));
          }
        }
      }
    }

    &:has(.vs-ect[data-layout='3up']),
    &:has(.vs-sct[data-layout='3up']) {
      li:first-child, li:only-child {
        @include breakpoints.desktop-plus-up {
          width: calc((1140px / 3) + ((100vw - 1140px) / 2));
          padding-right: 15px;
          padding-left: calc(((100vw - 1140px) / 2) + 15px);

          @include rtl.rtl {
            padding-left: 15px;
            padding-right: calc(((100vw - 1140px) / 2) + 15px);
          }
        }
      }

      li:last-child:not(:only-child) {
        @include breakpoints.desktop-plus-up {
          width: calc((1140px / 3) + ((100vw - 1140px) / 2));
          padding-left: 15px;
          padding-right: calc(((100vw - 1140px) / 2) + 15px);

          @include rtl.rtl {
            padding-right: 15px;
            padding-left: calc(((100vw - 1140px) / 2) + 15px);
          }
        }
      }
    }


    .vs-carousel-transition {
      transition: transform 200ms ease;
      -webkit-transition: transform 200ms ease;
      -webkit-backface-visibility: hidden;
      backface-visibility: hidden;
      -webkit-transform-style: preserve-3d;
      transform-style: preserve-3d;
    }

    .vs-carousel-transition-delay {
      -webkit-transition-property: none;
      -moz-transition-property: none;
      -o-transition-property: none;
      transition-property: none;
    }

  .vs-carousel-container-desktop-2up-2tiles-3up-3tiles {
  width: 100%;
  padding: 0 15px;

  .vs-carousel-desktop-list {
    display: flex;
    flex-wrap: nowrap;
    justify-content: center;
    width: 100%;

    li {
      width: auto !important;
      margin: 0 15px;
      padding: 0 15px !important;

      /* 2up layouts */
      &:has(.vs-content-bundle[data-layout='2up']),
      &:has(.vs-ect[data-layout='2up']),
      &:has(.vs-sct[data-layout='2up']),
      &:has(.vs-icon-bundle[data-layout='2up']),
      &:has(.vs-offer-bundle[data-layout='2up']) {
        width: calc(50% - 20px) !important;
        max-width: calc(570px) !important;
      }

      /* 3up layouts */
      &:has(.vs-content-bundle[data-layout='3up']),
      &:has(.vs-ect[data-layout='3up']),
      &:has(.vs-sct[data-layout='3up']),
      &:has(.vs-icon-bundle[data-layout='3up']),
      &:has(.vs-offer-bundle[data-layout='3up']) {
        width: calc(33.333% - 20px) !important;
        max-width: calc(370px) !important;
      }

      .vs-content-bundle[data-layout='2up'],
      .vs-ect[data-layout='2up'],
      .vs-sct[data-layout='2up'],
      .vs-icon-bundle[data-layout='2up'],
      .vs-offer-bundle[data-layout='2up'] {
        width: 100%;
      }

      .vs-content-bundle[data-layout='3up'],
      .vs-ect[data-layout='3up'],
      .vs-sct[data-layout='3up'],
      .vs-icon-bundle[data-layout='3up'],
      .vs-offer-bundle[data-layout='3up'] {
        width: 100%;
      }

      &:first-child {
        margin-left: 0;
      }

      &:last-child {
        margin-right: 0;
      }
    }
  }
}


  }
  .vs-carousel-media-button {
    background-color: white;
    display: inline-block;
    width: 50px;
    height: 50px;
    border: 2px solid black;
    border-radius: 50%;
    position: relative;

    &:before {
      font-family: 'visa-icon', sans-serif;
      font-size: 20px;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }

    &:hover {
      opacity: 0.6;
    }

    &.vs-carousel-play-button {
      &:before {
        content: "\e944";
      }
    }

    &.vs-carousel-pause-button {
      &:before {
        content: "\e943";
      }
    }

  }

  .vs-carousel-scroll {
    -webkit-appearance: none;
    appearance: none;
    width: 100%;
    height: 4px;
    background-color: #dedede;
    outline: none;
    opacity: 0.7;
    -webkit-transition: 0.2s;
    transition: opacity 0.2s;

    &::-webkit-slider-thumb {
      -webkit-appearance: none;
      appearance: none;
      width: var(--carousel-thumb-width, 80px);
      height: 4px;
      background: #808080;
      cursor: grab;
    }

    &::-moz-range-thumb {
      width: var(--carousel-thumb-width, 80px);
      height: 4px;
      background: #808080;
      cursor: grab;
    }

    &:active {
      &::-webkit-slider-thumb {
        background: #2c2c2c;
        outline: 1px dashed black;
        outline-offset: 2px;
      }

      &::-moz-range-thumb {
        background: #2c2c2c;
        outline: 1px dashed black;
        outline-offset: 2px;
      }
    }

    &:hover {
      &::-webkit-slider-thumb {
        background: #2c2c2c;
      }

      &::-moz-range-thumb {
        background: #2c2c2c;
      }
    }
  }

  .vs-ct-overlay li{
    padding-left: 0px !important;
    padding-right: 0px !important;
    width: auto !important;
  }
}
